<div class="container">
  <form class="mx-auto p-3 mt-5">
    <div class="text-center">
      <!-- <div>
        <div *ngIf="userData$ | async as userData">
          Is Authenticated: {{ isAuthenticated$ | async }}
          <br />
          expiration: {{ getExp(userData.exp)}}
          <br />
          <pre>{{ userData | json }}</pre>
        </div>
      </div> -->

      <div class="my-5 logo">
        <img src="/assets/img/logo.svg" />
      </div>

      <button class="login-button" mat-flat-button color="primary" (click)="login()">{{'Accedi' | translate}}</button>

      <!-- <button mat-flat-button color="primary" (click)="forceRefreshSession()">Refresh</button> -->
    </div>
  </form>
</div>
